<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column">
  <div class="detail_header_container" fxLayout="column" fxLayoutAlign="start left">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="detail_container_title" *ngIf="employee">
        <span>{{ employee.name }}</span>
      </div>
      <span class="expand"></span>
      <div class="action_buttons" *ngIf="employeeForm">
        <oneapp-button
          id="save_employee"
          [action]="buttonAction.SAVE"
          (buttonClick)="onSubmit()"
          [disabled]="!(employeeForm.valid && employeeForm.dirty)"
          form="employeeFormID"
          *epgIfPermitted="[OneAppPermission.EMPLOYEE_WRITE]"
        ></oneapp-button>
        <oneapp-button
          id="delete_employee"
          [action]="buttonAction.DELETE"
          (buttonClick)="onEmployeeDelete()"
          *epgIfPermitted="[OneAppPermission.EMPLOYEE_DELETE]"
        ></oneapp-button>
      </div>
    </div>
  </div>

  <div class="detail_data_container">
    <form
      [formGroup]="employeeForm"
      (ngSubmit)="onSubmit()"
      id="employeeFormID"
      *ngIf="employeeForm"
    >
      <div>
        <!-- Details -->
        <mat-card>
          <mat-card-header fxLayoutAlign="start center">
            <div fxLayout="row" fxFlex>
              <mat-card-title fxLayoutAlign="start center" i18n="detail panel header@@detail"
                >DETAIL</mat-card-title
              >
            </div>
          </mat-card-header>
          <mat-card-content>
            <div>
              <div class="formelement_container" fxLayout="row">
                <mat-form-field id="employee_username" appearance="outline">
                  <mat-label i18n="label for input field@@username">Username</mat-label>
                  <input
                    matInput
                    placeholder=""
                    formControlName="userName"
                    id="userName"
                    readonly
                  />
                </mat-form-field>
              </div>
            </div>
            <div>
              <div class="formelement_container" fxLayout="row">
                <mat-form-field id="employee_email" appearance="outline">
                  <mat-label i18n="label for input field@@email">E-Mail</mat-label>
                  <input matInput placeholder="" formControlName="email" id="email" required />
                  <mat-error
                    *ngIf="employeeForm.get('email')?.hasError('required')"
                    i18n="Email is required@@emailIsRequired"
                    >Email is required.</mat-error
                  >
                  <mat-error
                    *ngIf="employeeForm.get('email')?.hasError('email')"
                    i18n="Please enter a valid email@@pleaseEnterAValidEmail"
                    >Please enter a valid email.</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <!-- <div>
              <div class="formelement_container" fxLayout="row">
                <mat-form-field id="employee_name" appearance="outline">
                  <mat-label i18n="label for input field@@name">Name</mat-label>
                  <input matInput placeholder="" formControlName="name" id="name" />
                </mat-form-field>
              </div>
            </div> -->
            <div class="formelement_container" fxLayout="row">
              <mat-form-field id="employee_group_dropdown" appearance="outline">
                <mat-label i18n="employee group label@@employeeGroup">Employee group</mat-label>
                <mat-select formControlName="employee_group" id="employee_group" multiple>
                  <mat-option
                    [value]="empGroup.employeeGroupId"
                    *ngFor="let empGroup of employeeGroups"
                    >{{ empGroup?.name }}</mat-option
                  >
                  <mat-option *ngIf="employeeGroups.length === 0"></mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
        <!-- user rights -->
        <mat-card style="margin-top: 25px" *ngIf="isAdmin()">
          <mat-card-header fxLayoutAlign="start center">
            <div fxLayout="row" fxFlex>
              <mat-card-title fxLayoutAlign="start center" i18n="detail panel header@@userRoles"
                >USER ROLES</mat-card-title
              >
            </div>
          </mat-card-header>
          <mat-card-content>
            <div *ngIf="errorLoadingRoles">
              <span>{{ errorMessage }}</span>
            </div>
            <div class="formelement_container" *ngIf="!errorLoadingRoles" fxLayout="row">
              <mat-form-field id="employee_roles_dropdown" appearance="outline">
                <mat-label i18n="label for input field@@employeeRolesLabel">Roles</mat-label>
                <mat-select formControlName="roles" id="roles" multiple>
                  <mat-option [value]="role.name" *ngFor="let role of roles">{{
                    role.name
                  }}</mat-option>
                  <mat-option *ngIf="roles.length === 0"></mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </form>
  </div>
</div>
